import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchStoreMembersAPI(storeId , filters) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/member/store/${storeId}?${getQueryString(filters)}`)
}